@use "../../../styles/breakpoint.module.scss" as *;

.bar {
    --gutters: calc(var(--spokes) - 1);
    --bar-padding: var(--spacer-40);
    --bar-gap: var(--spacer-16);
    --gutter-space: calc(var(--bar-gap) * var(--gutters));
    --item-width: calc(
        (100% - 2 * var(--bar-padding) - var(--gutter-space)) / var(--spokes)
    );

    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--bar-gap);
    width: 100%;
    max-width: 900px;
    margin-inline: auto;
    padding-inline: var(--bar-padding);
    z-index: 0;

    @media ($below-mobile) {
        --bar-padding: 0px;
    }

    &::before {
        content: "";
        position: absolute;
        inset-inline: calc(var(--bar-padding) + var(--item-width) / 2);
        top: 11px;
        height: 2px;
        background-color: var(--gray-300);
        z-index: -1;
    }
}

.item {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    width: var(--item-width);
    gap: var(--spacer-8);
}

.itemActive {
    composes: item;
}

.glyph {
    display: block;
    width: 24px;
    height: 24px;
    background-color: var(--color-primary);
    border-radius: 50%;
}

.label {
    font: var(--font-eyebrow-12);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--gray-500);

    @media ($below-mobile) {
        display: none;
    }

    .itemActive & {
        color: var(--gray-900);

        @media ($below-mobile) {
            display: block;
        }
    }
}
